import styled, { css } from "styled-components/macro";
import {
  darkGrey,
  lighterGrey,
  medGrey,
  medText,
  blueButton,
  brightBlue,
  darkModeTitleBackgroundColor,
  darkModeTextColor,
  darkModeDarkTextColor,
  darkModeLinkColor,
  lightGrey,
  medDarkGrey,
} from "../../../../../constants/colors";
import {
  BREAKPOINT_TABLET,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_SMALL,
  CURRENT_SHIFT_WIDTH,
  Z_INDEX,
  BREAKPOINT_MOBILE,
} from "../../../../../constants/constants";

const VISIBLE_SHIFT_PICKERS_WIDTH = BREAKPOINT_MOBILE;
const CLICKABLE_WIDTH = BREAKPOINT_MOBILE * 2;

export const SHIFTPICKER_WIDTH = 22;
export const SHIFTPICKER_MARGIN = 3;
export const MAX_SHIFTS_PER_DAY = 4;
export const SHIFT_CAROUSEL_MARGIN = 6;

// const AVG_SHIFT_CAROUSEL_WIDTH =
//   MAX_SHIFTS_PER_DAY * (SHIFTPICKER_WIDTH + 2 * SHIFTPICKER_MARGIN) +
//   2 * SHIFT_CAROUSEL_MARGIN;

const gradientLight = "rgba(239,240,241,1)";
const transparentLight = "rgba(239,240,241,0)";
const gradientDark = "rgba(83,83,83,1)"; // => darkModeTitleBackgroundColor in rgba;
const transparentDark = "rgba(83,83,83,0)";
const getLinearGradient = isDarkMode => {
  const gradientColor = isDarkMode ? gradientDark : gradientLight;
  const transparent = isDarkMode ? transparentDark : transparentLight;
  return `
background: -moz-linear-gradient(left, ${gradientColor} 0%, ${gradientColor} calc(50% - ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${transparent} 50%, ${gradientColor} calc(50% + ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${gradientColor} 100%);
background: -webkit-gradient(left top, right top, color-stop(0%, ${gradientColor}), color-stop(calc(50% - ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${gradientColor}), color-stop(50%, ${transparent}), color-stop(calc(50% + ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${gradientColor}), color-stop(100%, ${gradientColor}));
background: -webkit-linear-gradient(left, ${gradientColor} 0%, ${gradientColor} calc(50% - ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${transparent} 50%, ${gradientColor} calc(50% + ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${gradientColor} 100%);
background: -o-linear-gradient(left, ${gradientColor} 0%, ${gradientColor} calc(50% - ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${transparent} 50%, ${gradientColor} calc(50% + ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${gradientColor} 100%);
background: -ms-linear-gradient(left, ${gradientColor} 0%, ${gradientColor} calc(50% - ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${transparent} 50%, ${gradientColor} calc(50% + ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${gradientColor} 100%);
background: linear-gradient(to right, ${gradientColor} 0%, ${gradientColor} calc(50% - ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${transparent} 50%, ${gradientColor} calc(50% + ${
    VISIBLE_SHIFT_PICKERS_WIDTH / 2
  }px), ${gradientColor} 100%);
@media print {
  background: none;
}
`;
};

export const HOVER_UNDERLINE_CSS = `
color: ${blueButton};
background: none;
cursor: pointer;
border: none;
padding: 0;
&:after {
  content: "";
  border-bottom: 1px solid ${brightBlue};
  position: absolute;
  bottom: 0;
  width: 0%;
  left: 50%;
  right: 0;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}
&:hover {
  color: ${brightBlue};
  &:after {
    width: 100%;
    left: 0%;
  }
}
`;
const SHIFTSELECTOR_PADDING_HZ = 20;

export const ShiftSelectorStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  .placeholder {
    margin: auto;
    line-height: 1.5em;
  }
  .backIcon {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
    padding: 0;
    margin: 0;
    margin-right: 3px;
  }
  .backIcon,
  .forwardIcon {
    font-size: 30px;
    margin-top: -2px;
  }
  .forwardIcon {
    margin-left: 3px;
  }
  .shiftSelector {
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    background: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeTitleBackgroundColor : lighterGrey};
    padding: 8px ${SHIFTSELECTOR_PADDING_HZ}px 8px ${SHIFTSELECTOR_PADDING_HZ}px;
    @media (min-width: ${BREAKPOINT_TABLET}px) {
      padding: 8px 0px 4px 0px;
    }
    height: 90px;
    text-align: center;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 60px;
      bottom: 0;
      ${({ $isDarkMode }) => getLinearGradient($isDarkMode)}
      pointer-events: none;
    }
    .btnDiv {
      width: 50px;
      display: flex;
      align-items: center;
    }
    .btn {
      outline: none;
      cursor: pointer;
      width: 50px;
      height: 50px;
      background: none;
      border: none;
      &:hover {
        span:nth-child(2) {
          background: rgba(0, 0, 0, 0.13);
        }
      }
    }
    .shiftBtn {
      position: absolute;
      bottom: 2px;
      &.btnBack {
        left: calc(
          50% -
            ${(SHIFTPICKER_WIDTH + SHIFTPICKER_MARGIN) * MAX_SHIFTS_PER_DAY -
            SHIFTPICKER_MARGIN}px
        );
      }
      &.btnForward {
        right: calc(
          50% -
            ${(SHIFTPICKER_WIDTH + SHIFTPICKER_MARGIN) * MAX_SHIFTS_PER_DAY -
            SHIFTPICKER_MARGIN}px
        );
      }
      width: 20px;
      height: 20px;
      padding: 0;
      svg {
        margin-top: 0px;
        height: 100%;
        width: 100%;
      }
      transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
      transform: none;
    }
  }

  .selectorArea {
    position: relative;
  }
  .shiftPickersContainer {
    margin: 0 ${SHIFT_CAROUSEL_MARGIN}px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.inFuture {
      pointer-events: none;
    }

    &:not(.today) .shiftPicker {
      opacity: 0.3;
    }

    .shiftPickerAndOverlayWrapper {
      position: relative;
      min-height: ${SHIFTPICKER_WIDTH + SHIFTPICKER_MARGIN * 2}px;
      min-width: ${SHIFTPICKER_WIDTH + SHIFTPICKER_MARGIN * 2}px;
      max-height: ${SHIFTPICKER_WIDTH + SHIFTPICKER_MARGIN * 2}px;
      max-width: ${SHIFTPICKER_WIDTH + SHIFTPICKER_MARGIN * 2}px;
      &.inFuture {
        opacity: 0;
        button {
          cursor: default;
        }
      }
    }
    .shiftPicker {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      transition:
        opacity 0.25s ease-in,
        background 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
      position: relative;
      border: 1px solid
        ${({ $isDarkMode }) => ($isDarkMode ? lightGrey : darkGrey)};
      &.overlay {
        /* transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1); */
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        left: ${SHIFTPICKER_MARGIN}px;
        border: none;
        margin: 0;
        margin-top: -1px;
        width: 100%;
        height: 100%;
        /* &.internetExplorer {
          display: none;
        } */
        /* transform: scale(0);
        &.selected {
          transform: scale(1);
        } */
        background: ${({ $isDarkMode }) =>
          $isDarkMode ? lightGrey : darkGrey};
      }
      background: none;
      cursor: pointer;

      &:hover:not(.selected) {
        background: ${({ $isDarkMode }) =>
          $isDarkMode ? medDarkGrey : medGrey};
      }

      min-height: ${SHIFTPICKER_WIDTH}px;
      min-width: ${SHIFTPICKER_WIDTH}px;
      max-height: ${SHIFTPICKER_WIDTH}px;
      max-width: ${SHIFTPICKER_WIDTH}px;
      padding: 0;
      margin: 6px ${SHIFTPICKER_MARGIN}px 0 ${SHIFTPICKER_MARGIN}px;
    }
    &.today .inFuture {
      opacity: 0.3;
      .shiftPicker {
        border-style: dashed;
      }
    }
  }
  .currentPeriod {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    .selectorArea {
      width: 100%;
    }
  }
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    .periodSelector .currentPeriod .shift {
      width: ${CURRENT_SHIFT_WIDTH + 175}px;
    }
    .shift {
      font-size: ${FONT_SIZE_SMALL}px;
    }
    .selectorTitle {
      font-size: ${FONT_SIZE_MEDIUM}px;
    }
  }
  .pointerEventsNone {
    pointer-events: none;
  }
  .fadeOut {
    &.btnForward {
      transform: translateX(-20px) scale(0.25);
    }
    &.btnBack {
      transform: translateX(20px) scale(0.25);
    }
    &.shiftPickersContainer {
      height: 0;
    }
    opacity: 0;
    pointer-events: none !important;
  }
  .fadeOutTransition {
    transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  @media print {
    .selectorArea {
      .shiftInfoAndButtons {
        max-width: 100%;
      }
    }
  }
`;

export const BlockClicksLeft = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  width: calc(50% - ${CLICKABLE_WIDTH / 2}px);
`;
export const BlockClicksRight = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  width: calc(50% - ${CLICKABLE_WIDTH / 2}px);
`;

export const ShiftPickersRowStyles = styled.div`
  height: 30px;
  position: relative;
  display: flex;
  width: 100%;
  max-width: 100vw;
  justify-content: center;
  .carousels {
    display: flex;
    position: absolute;
    left: 0;
  }
  .carousels {
    margin-left: -${SHIFTSELECTOR_PADDING_HZ}px;
  }
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    .carousels {
      margin-left: 0px;
    }
  }
  @media print {
    .selectorArea {
      .shiftInfoAndButtons,
      .shiftCarouselsWrapper {
        max-width: 100%;
      }
    }
  }
`;

export const ShiftInfoAndButtonsStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  height: 44px;
  .iconButtonWrapper {
    z-index: ${Z_INDEX.L3};
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    pointer-events: none;
    button {
      pointer-events: auto;
    }
    &.forward {
      right: -16px;
    }
    &.back {
      left: -16px;
    }
    @media (min-width: ${BREAKPOINT_TABLET}px) {
      position: relative;
    }
  }
  width: 100%;
  max-width: 100vw;
  display: flex;
  justify-content: center;
  position: relative;
  .shiftInfo {
    height: 100%;
    width: 100%;
    display: flex;
    width: ${CURRENT_SHIFT_WIDTH + 120}px;
    flex-direction: column;
    justify-content: center;
    position: relative;
    .shiftName {
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTextColor : "#000000"};
      position: absolute;
      left: 0;
      top: 0px;
      right: 0;
      display: flex;
      justify-content: center;
    }
    .shiftTime {
      margin: 9px 0 3px 0;
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeDarkTextColor : medText};
      position: absolute;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      bottom: 0;
    }
    .btnToggleFullDay {
      position: absolute;
      right: -10px;
      top: 1px;
      width: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 1em;
      ${HOVER_UNDERLINE_CSS}
      ${({ $isDarkMode }) =>
        $isDarkMode
          ? css`
              color: ${darkModeLinkColor};
            `
          : ``}
    }
  }
`;
